<template>
  <div>
    <v-layout wrap align-center>
      <v-card dark style="border-radius: 10px;width: 100%;">
        <v-form v-model="valid" ref="searchForm">
          <v-layout justify-end row wrap class="pa-3">
            <v-flex xs12 sm4 class="pl-2">
              <v-autocomplete
                prepend-icon="store_mall_directory"
                :items="store_list"
                item-text="store_name_th"
                item-value="store_id"
                v-model="form.store_id"
                :loading="isLoading"
                label="กรุณาเลือกร้านค้าที่ร่วมแคมเปญ"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm3 class="pl-2">
              <v-menu
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="-30"
                lazy
                transition="scale-transition"
                offset-y
                style="width: 100%"
              >
                <v-text-field
                  label="Start"
                  slot="activator"
                  prepend-icon="event"
                  readonly
                  v-model="form.datetime_start"
                  :rules="[(v) => !!v || 'required']"
                ></v-text-field>
                <v-date-picker
                  color="#333"
                  no-title
                  @input="
                    menu1 = false;
                    form.datetime_start = $event;
                  "
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3 class="pl-2">
              <v-menu
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="-30"
                lazy
                transition="scale-transition"
                offset-y
                style="width: 100%"
              >
                <v-text-field
                  label="End"
                  slot="activator"
                  prepend-icon="event"
                  readonly
                  v-model="form.datetime_end"
                  :rules="[
                    (v) => !!v || 'required',
                    (v) =>
                      v >= form.datetime_start ||
                      'End date must more than start date',
                  ]"
                ></v-text-field>
                <v-date-picker
                  :min="moment(form.datetime_start).format('YYYY-MM-DD')"
                  color="#333"
                  no-title
                  @input="
                    menu2 = false;
                    form.datetime_end = $event;
                  "
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex
              xs12
              sm2
              style="display: flex; justify-content: center; align-items: center"
            >
              <div class="pt-2 text-xs-center search-btn" @click="search()">
                <v-progress-circular
                  indeterminate
                  color="black"
                  v-if="searching"
                ></v-progress-circular>
                <v-icon large color="black" v-else>search</v-icon>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
    </v-layout>
    <v-data-table
      :loading="loading_form"
      :headers="headers"
      :items="filteredReportList"
      class="elevation-1 mt-3"
      style="background-color:white;padding:10px; border-radius:10px;"
      :rows-per-page-items="[10, 25, 50]"
    >
      <template slot="headerCell" slot-scope="props">{{
        props.header.text
      }}</template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ report_dinein.indexOf(props.item) + 1 }}
        </td>
        <td>{{ props.item.order_code }}</td>
        <td>{{ props.item.order_customer_name }}</td>
        <td>{{ props.item.order_store_name }}</td>
        <td>{{ props.item.order_total_price }}</td>
        <td>{{ props.item.store_commission }}</td>
        <td>
          {{ calculate(props) }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      form: { datetime_start: null, datetime_end: null ,store_id:null},
      menu1: false,
      menu2: false,
      valid: true,
      loading_form: false,
      searching: false,
      search_input: "",
      isLoading: false,
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name",
        },
        { text: "Order code", value: "id", sortable: false },
        { text: "Customer name.", value: "id", sortable: false },
        { text: "Store name", value: "store_name", sortable: false },
        { text: "Item total price ", value: "store_name", sortable: false },
        { text: "Store Comission", value: "store_name", sortable: false },
        {
          text: "Revenue",
          value: "item_price",
          sortable: false,
          align: "center",
        },
      ],
    };
  },
  watch: {
    ///
  },
  methods: {
    ...mapActions({
      getReportlist: "report/getReportDineIn",
    }),
    async search() {
      if (this.$refs.searchForm.validate()) {
        this.searching = true;
        this.loading_form = true;
        let res = await this.getReportlist(this.form);
        if (res == false) {
          alert("Erorr form server");
          this.loading_form = false;
          this.searching = false;
        }
        this.loading_form = false;
        this.searching = false;
      }
    },
    calculate(props) {
      return (
        props.item.order_total_price -
        (props.item.order_total_price * props.item.store_commission) / 100
      );
    },
    async initialize() {
      this.isLoading = true;
      await this.$store.dispatch("fetchDineIn/getAllDineInStore", {
        page_size: 999999999,
        current_page: 1,
      });
      this.isLoading = false;
    },
  },
  computed: {
    ...mapState({
      report_dinein: (state) => state.report.report_dinein,
      currentStoreId: (state) => state.storeBack.store_detail_id,
      store_list: (state) => state.fetchDineIn.store_list,
    }),
    filteredReportList() {
      return this.report_dinein
    },
  },
  mounted() {
    this.$store.commit("report/setReportDinein", []);
    this.initialize();
  },
};
</script>
<style scoped>
.search-btn {
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
  padding: 0 10px;
  cursor: pointer;
}
</style>
